'use strict';

import * as util from '../util/Common.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import * as iiifUtil from '../util/IIIFUtil.js';
import * as domItem from '../viewer/DomItem.js';

const privateMap = util.createPrivateMapper();

function appendItem(langTargets, container, item){
  if (item.langMap) {
    langTargets.push({
      container: container,
      defaultValue: item.defaultValue,
      valueMap: item.langMap
    });
  } else {
    container.appendChild(item.domEl);
  }
}
function addData(dl, label, value) {
  if (!label || !value) {
    return;
  }

  let valueItems;
  if (util.isArray(value)) {
    valueItems = [];
    util.each(value, (v) => {
      const valueItem = domItem.getDomItem(v);
      if (!valueItem) {
        return;
      }
      valueItems.push(valueItem);
    })
  } else {
    valueItems = []
    const valueItem = domItem.getDomItem(value);
    if (valueItem) {
      valueItems.push(valueItem);
    }
  }
  if (!valueItems || valueItems.length == 0) {
    return;
  }

  const labelItem = domItem.getDomItem(label);
  if (!labelItem) {
    return;
  }

  const langTargets = [];

  const dt = domUtil.createElement('dt');
  dl.appendChild(dt);
  appendItem(langTargets, dt, labelItem);

  const dd = domUtil.createElement('dd');
  dl.appendChild(dd);
  if (valueItems.length == 1) {
    appendItem(langTargets, dd, valueItems[0]);
  } else {
    const ul = domUtil.createElement('ul');
    dd.appendChild(ul);
    util.each(valueItems, (valueItem) => {
      const li = domUtil.createElement('li');
      ul.appendChild(li);
      appendItem(langTargets, li, valueItem);
    });
  }
  return langTargets;
}

export class MetadataView extends UiComponent {
  constructor(domEl, options){
    super(domEl);
    const pv = privateMap(this);
    options = options ? options : {};
    pv.attributes = options.attributes ? options.attributes : [
      'label',
      'description',
      'attribution',
      'license',
      'logo',
      'metadata',
      'related',
      'seeAlso',
      'rendering'
    ];
    pv.labelMap = options.labelMap;
    pv.languageControl = options.languageControl;
    pv.postProcess = options.postProcess;
    this.active = false;
  }

  set metadata(data){
    const pv = privateMap(this);
    domUtil.empty(this.domEl);
    this.active = false;
    if (!data) {
      return;
    }
    const dlEl = domUtil.createElement('dl');

    util.each(pv.attributes, (attr) => {
      if (attr == 'metadata' && data.metadata) {
        const l = data.metadata.length;

        util.each(data.metadata, (m) => {
          const langTargets = addData(dlEl, m.label, m.value);
          if (langTargets) {
            pv.languageControl.addTarget(langTargets);
          }
        })
      } else {
        const label = (pv.labelMap && pv.labelMap[attr]) ? pv.labelMap[attr] : attr;
        const langTargets = addData(dlEl, {
          type: domItem.DataTypes.Text,
          text: {
            '@none': [label]
          }
        }, data[attr]);
        if (langTargets) {
          pv.languageControl.addTarget(langTargets);
        }
      }
    });
    if (!dlEl.innerHTML.length) {
      return;
    }
    this.domEl.appendChild(dlEl);
    if (pv.postProcess){
      pv.postProcess(this.domEl)
    }
    this.active = true;
  }
}